import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAuth } from "src/contexts/AuthContext";

const PrivateRoute: React.FC<RouteProps> = (props) => {
  const auth = useAuth();

  return !auth?.isLoggedIn && !auth?.isLoading ? (
    <Redirect to="/" />
  ) : (
    <Route {...props} />
  );
};

export default PrivateRoute;
